// src/pages/PurchaseAccountLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import PurchaseAccountLedgerFilters from "./components/PurchaseAccountLedgerFilters";
import PurchaseAccountLedgerTable from "./components/PurchaseAccountLedgerTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const PurchaseAccountLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.purchaseAccountLedger);
  const navigate = useNavigate();

  const reportRef = useRef(null);

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Purchase Account Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Purchase Account Ledger
            </Title>
            </div>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <PurchaseAccountLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <PurchaseAccountLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Purchase Account Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <PurchaseAccountLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default PurchaseAccountLedger;
